import React, { useEffect } from 'react';
import $ from 'jquery';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEye, faPencil } from '@fortawesome/free-solid-svg-icons';

const SupplierSimpleTable = ({ columns, rows, handleShow, handleShowUpdate, handleDelete}) => {

    useEffect(() => {
        //initialize datatable
        $(document).ready(function () {
            setTimeout(function () {
                $('#datatable').DataTable({
                    retrieve: true,
                    pageLength: 5,
                    lengthMenu: [[5, 10, 15, 20, 25, -1], [5, 10, 15, 20, 25, 'All']]
                });
            }, 10);
        });
    });

    console.log('rows', rows);
    
    return (
        <div className='table-responsive'>
            <table id="datatable" className="table table-hover">
                <thead>
                    <tr>
                        {columns && columns.map((col, i ) => (
                            <th key={i.toString()} scope="col">{col.label}</th>
                        ))}
                        <th  scope="col">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {rows && rows.map((row, i) => (
                        <tr key={i.toString()}>
                            {Object.values(row).map((value, i) => (
                                <td key={i}>{value}</td>
                            ))}
                            <td>
                                <div className='operation-buttons'>
                                    <button className="btn btn-primary" onClick={()=>handleShow(row)}>
                                        <FontAwesomeIcon icon={faEye} />
                                    </button>
                                    <button className="btn btn-success" onClick={()=>handleShowUpdate(row)} >
                                        <FontAwesomeIcon icon={faPencil} />
                                    </button>
                                    <button className="btn btnDel btn-danger" onClick={()=>handleDelete(row.productId)}>
                                        <FontAwesomeIcon icon={faTrash} />    
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default SupplierSimpleTable;